export default "__VITE_ASSET__327faf28__"